const colors = {
    lightBlue: '#48D1CC', //Color Name: Medium Turquoise
    black: 'black',
    white: '#ffffff',
    gray: 'gray',
    lightGray: '#f3f3f3',
    darkGray: '#333333',
    footerBlack: '#1e1e1e'
  };
  
  export default colors;
  